<template>
    <TheAzModule
        :title="t('treatments-all')"
        :description="t('treatments-az')"
        :links="conditions"
    />
</template>

<script setup lang="ts">
import ConditionsQuery from '~/graphql/queries/Conditions.graphql';
import TheAzModule from '~/components/TheAzModule/TheAzModule.vue';

const { activeSite } = useMultisite();
const { variables } = useCraftGraphqlSlug();
const response = await useLazyAsyncQuery({
    query: ConditionsQuery,
    variables: {
        ...toValue(variables),
        type: ['treatment']
    }
});

const {craftEntry: conditions } = usePageQuery(
    response,
    { entryKey: 'conditions', activeSite }
);

const t = useTranslation('context-nav');
</script>
